'use strict';

var _ = require('lodash');
var StrategyActionFactory = function StrategyActionFactory($filter, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var rmPercent = $filter('rmPercent');
  function StrategyAction(params) {
    this.category = params.category || '';
    this.criterion = params.criterion || '';
    this.action = params.action || '';
    this.argsNo = params.argsNo || '';
    this.field = params.field || '';
    this.level = params.level || '';
    this.value = params.value || params.value === 0 ? params.value : '';
    this.formattedValue = formatValue(this.value, params.fieldType);
    this.secondValue = params.secondValue || params.secondValue === 0 ? params.secondValue : '';
    this.formattedSecondValue = formatValue(this.secondValue, params.fieldType);
    this.thirdValue = params.thirdValue || params.thirdValue === 0 ? params.thirdValue : '';
    this.formattedThirdValue = formatValue(this.thirdValue, params.fieldType);
    this.criteriaType = params.criteriaType || params.criteriaType === 0 ? params.criteriaType : '';
    this.formattedCriteriaType = formatValue(this.criteriaType, params.fieldType);
  }
  function formatValue(value, fieldType) {
    if (momentService.isMoment(value)) {
      var momentFormat = value.isTime() ? 'TIME_USER_SETTINGS' : 'DATE_USER_SETTINGS';
      return rmMomentFormat(value, momentFormat);
    }
    if (_.isObject(value) && _.has(value, 'dropdownVisibleValue')) {
      return value.dropdownVisibleValue;
    }
    if (_.isArray(value)) {
      return value.join(', ');
    }
    if (fieldType === 'percent' || fieldType === '2percent') {
      return rmPercent(value);
    }
    return value;
  }
  StrategyAction.prototype.isEqual = function (obj) {
    return _.isEqual(this.category, obj.category) && _.isEqual(this.criterion, obj.criterion) && _.isEqual(this.action, obj.action) && _.isEqual(this.field, obj.field) && _.isEqual(this.level, obj.level) && _.isEqual(this.value, obj.value) && _.isEqual(this.secondValue, obj.secondValue) && _.isEqual(this.thirdValue, obj.thirdValue);
  };
  StrategyAction.prototype.isValueEmpty = function () {
    var valueEmpty = this.value === '' || this.value === null || this.value === undefined;
    var secondValueEmpty = '';
    if (this.argsNo === '2') {
      secondValueEmpty = this.secondValue === '' || this.secondValue === null || this.secondValue === undefined;
      return valueEmpty || secondValueEmpty;
    } else if (this.argsNo === '3') {
      secondValueEmpty = this.secondValue === '' || this.secondValue === null || this.secondValue === undefined;
      var thirdValueEmpty = this.thirdValue === '' || this.thirdValue === null || this.thirdValue === undefined;
      return valueEmpty || secondValueEmpty || thirdValueEmpty;
    }
    return valueEmpty;
  };
  StrategyAction.prototype.isEmpty = function () {
    return _.isEmpty(this.category) && _.isEmpty(this.criterion) && _.isEmpty(this.action) && _.isEmpty(this.field) && this.isValueEmpty();
  };
  StrategyAction.prototype.isValid = function () {
    return !(_.isEmpty(this.category) || _.isEmpty(this.criterion) || _.isEmpty(this.action) || _.isEmpty(this.field)) && (this.action === 'Remove' || !this.isValueEmpty());
  };
  StrategyAction.prototype.toString = function () {
    return [this.category, this.criterion, this.action, this.value, this.field, this.level, this.secondValue, this.thirdValue].join(' ');
  };
  StrategyAction.prototype.createCopy = function () {
    return new StrategyAction(this);
  };
  return StrategyAction;
};
StrategyActionFactory.$inject = ['$filter', 'MomentService'];
module.exports = StrategyActionFactory;